import Connector from './prototype';
import Device from '../model/Device';
import User from '../model/User';
import Game from '../model/Game';
import GameProduct from '../model/GameProduct';
import Role from '../model/Role';
import ChannelPlatform from '../model/ChannelPlatform';

if (process.env.NODE_ENV === 'development' && process.env.DATA_FAKE) {
  window.android = {
    getUser() {
      return JSON.stringify({
        user_id: '123',
        access_token: '123',
      });
    },
    getDevice() {
      return JSON.stringify({
        os_type: 'ios',
        net_type: '4g',
        user_agent: '',
        android_adv_id: '',
        ios_idfa: '31C98A5A-5733-4004-BC07-87D5BD0B8BFC',
        android_id: '',
        package_name: 'com.indie.wyfx.jt',
        screen_height: '2208',
        device_name: 'iPhone',
        device_id: '31C98A5A-5733-4004-BC07-87D5BD0B8BFC',
        android_imei: '',
        screen_width: '1242',
        os_ver: '11.2.2',
        sdk_ver: '2.0.0',
      });
    },
    getChannelPlatform() {
      return JSON.stringify({
        ad_id: 'appstore',
      });
    },
    callExit() {
      // eslint-disable-next-line
      console.log('android exit calling');
    },
    getGame() {
      return JSON.stringify({
        game_id: '10086',
        game_name: '九州行',
        game_ver: '1.0.0',
      });
    },
    getGameProduct() {
      return JSON.stringify({
        currency_amount: '3.99',
        currency_code: 'USD',
        out_trade_no: 'default',
        product_id: 'com.guangyu.product.1',
        product_name: '元宝',
        product_count: '30',
        request_url: 'http://www.baidu.com',
      });
    },
    getRole() {
      return JSON.stringify({
        role_level: '100',
        role_name: '动动脑筋',
        server_id: '10',
        server_name: '123456',
        role_id: '10086',
        role_type: 'jianshi',
        role_gender: '10',
        association_id: '1000',
        association_name: '瞎鸡巴玩',
        association_rank: '瞎鸡巴玩',
      });
    },
    getSign() {
      return 'default sign';
    },
    showToast(str) {
      // eslint-disable-next-line
      console.log(str);
    },
    pay(payChannelId, params) {
      // eslint-disable-next-line
      console.log(`start pay with ${payChannelId} and params ${params}`);
    },
    notifyPayResult(jsonStr) {
      // eslint-disable-next-line
      console.log(`pay finish with ${jsonStr}`);
    },
    onEvent(event, jsonStr) {
      // eslint-disable-next-line
      console.log(`on event with ${event} and extras ${jsonStr}`);
    },
  };
}

function obj2Model(obj, model) {
  const newModel = model;
  const keys = Object.keys(model);
  for (let i = 0; i < keys.length; i += 1) {
    if (obj[keys[i]] !== undefined) {
      newModel[keys[i]] = obj[keys[i]];
    }
  }
  return newModel;
}

const connector = new Connector();

connector.getDevice = () => {
  const device = new Device();
  const obj = JSON.parse(window.android.getDevice());
  return obj2Model(obj, device);
};

connector.getUser = () => {
  const user = new User();
  const obj = JSON.parse(window.android.getUser());
  console.log(window.android.getUser());
  return obj2Model(obj, user);
};


connector.getGame = () => {
  const game = new Game();
  const obj = JSON.parse(window.android.getGame());
  return obj2Model(obj, game);
};


// 获取删除用户信息
connector.getDelInfo = () => JSON.parse(window.android.getDelInfo());
connector.getGameProduct = () => {
  const gameProduct = new GameProduct();
  const obj = JSON.parse(window.android.getGameProduct());
  return obj2Model(obj, gameProduct);
};

connector.getRole = () => {
  const role = new Role();
  const obj = JSON.parse(window.android.getRole());
  return obj2Model(obj, role);
};

connector.getChannelPlatform = () => {
  const channelPlatform = new ChannelPlatform();
  const obj = JSON.parse(window.android.getChannelPlatform());
  return obj2Model(obj, channelPlatform);
};

connector.callExit = () => {
  window.android.callExit();
};
connector.finishPay = () => {
  window.android.finishPay();
};
connector.getSign = jsonStr => window.android.getSign(jsonStr);
connector.changePassword = jsonStr => window.android.changePassword(jsonStr);
connector.showToast = (str) => {
  window.android.showToast(str);
};

connector.pay = (payChannelId, params) => {
  let fixed = '{}';
  if (params) {
    fixed = params;
  }
  window.android.pay(payChannelId, fixed);
};

connector.notifyPayResult = (jsonStr) => {
  window.android.notifyPayResult(jsonStr);
};
connector.openDetail = () => {
  window.android.openDetail();
};
connector.getUrls = () => JSON.parse(window.android.getUrls());

connector.onEvent = (event, jsonStr) => {
  window.android.onEvent(event, jsonStr);
};

// 接口访问
connector.postMessage = (msg) => {
  console.log(msg);
  window.android.postMessage(JSON.stringify(msg));
};
export default connector;



// WEBPACK FOOTER //
// ./src/common/js/native/android.js